import $ from 'jquery';
import ClipboardJS from 'clipboard';
import SelectService from '../service/SelectService';
import Api from '../util/Api';
import { intersection } from 'lodash';
import ReferralProductItem from '../template/ReferralProductItem';

let progress = false;
$('.referral-form--create').submit(function (e) {
    e.preventDefault();
    if (progress) {
        return;
    }
    progress = true;
    Api.post('/api/referral/create/', new FormData(this)).then(() => {
        window.location = '/personal/referral';
    });
});

$('.referral-form--update').submit(function (e) {
    e.preventDefault();
    if (progress) {
        return;
    }
    progress = true;
    Api.post('/api/referral/update/', new FormData(this)).then(() => {
        window.location = '/personal/referral';
    });
});

$('.referral-delete').click(function () {
    if (!window.confirm('Are you sure you want to delete this referral link?')) {
        return;
    }
    const CODE = $(this).attr('data-code');
    Api.post('/api/referral/delete/', {
        CODE
    }).then(() => {
        $(this).parents('.accordion--simple').remove();
    });
});

SelectService.onChange('REFERRAL_TYPE', (value) => {
    $('.referral__field--basket, .referral__field--product').hide();
    $(`.referral__field--${value}`).show();
});

function enableProductSelection(index = '') {
    SelectService.onChange(`PRODUCT${index}_CATEGORY`, (value) => {
        const subcategories = window.categories.filter((category) => {
            return category.iblock_section_id === value;
        });
        const productCategoryIds = [value, ...subcategories.map(category => category.id)];

        SelectService.setOptions(`PRODUCT${index}_SUBCATEGORY`, subcategories);
        SelectService.setValue(`PRODUCT${index}_SUBCATEGORY`, false);

        SelectService.setOptions(`PRODUCT${index}`, window.products.filter((product) => {
            return intersection(productCategoryIds, product.groups).length > 0;
        }));
    });
    SelectService.onChange(`PRODUCT${index}_SUBCATEGORY`, (value) => {
        if (value) {
            SelectService.setOptions(`PRODUCT${index}`, window.products.filter((product) => {
                return product.groups.indexOf(value) !== -1;
            }));
        }
        SelectService.setValue(`PRODUCT${index}`, false);
    });
}

enableProductSelection(); // Выбор продукта для ссылки на продукт
let nextProductIndex = $('.referral__product').length;
for (let index = 0; index < nextProductIndex; index++) { // Выбор продуктов для ссылки на корзину
    enableProductSelection(index);
}

$('.referral__add-product').on('click', function () {
    const newProduct = ReferralProductItem({
        index: nextProductIndex,
        fieldName: 'PRODUCTS',
        categories: window.categories.filter(category => !category.iblock_section_id),
        products: window.products,
    });
    $('.referral__products').append(newProduct);

    enableProductSelection(nextProductIndex++);
});
$('body').on('click', '.referral__remove-product', function () {
    $(this).parents('.referral__product').remove();
});

const clipboard = new ClipboardJS('.referral-link__copy');

clipboard.on('success', (e) => {
    const button = $(e.trigger);
    button.text(button.attr('data-success'));
    setTimeout(() => {
        button.text(button.attr('data-text'));
    }, 2000);
});
